import {
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  RollbackOutlined
} from '@ant-design/icons/lib';
import {TagProps} from 'antd/es/tag';
import React from 'react';
import {colors} from 'lib/colors';
import {EventType} from 'types';
import {StatusTag} from './StatusTag';

interface Props extends TagProps {
  type: EventType;
}

export const EventTypeTag: React.FC<Props> = ({type, ...props}) => {
  switch (type) {
    case EventType.CHARGE_AUTHORIZED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment authorized <ClockCircleOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_FAILED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment failed <CloseOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_CANCELED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment canceled <CloseOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_EXPIRED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment expired <CloseOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_PENDING:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment started <ClockCircleOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_PENDING_PROCESSING:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment pending processing <ClockCircleOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_REFUNDED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment refunded <RollbackOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_PARTIALLY_REFUNDED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment partially refunded <RollbackOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_SUCCEEDED:
      return (
        <StatusTag {...props} color={colors.success}>
          Payment succeeded <CheckOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_CAPTURED:
      return (
        <StatusTag {...props} color={colors.success}>
          Payment captured <CheckOutlined />
        </StatusTag>
      );
    case EventType.CHARGE_UPDATED:
      return (
        <StatusTag {...props} color={colors.grey}>
          Payment updated
          <ClockCircleOutlined />
        </StatusTag>
      );
  }

  return null;
};
